import { forEach } from 'lodash';

export * from './google-analytics';
export * from './quora-pixel';

class AnalyticsService {
    configure(providers) {
        this.providers = providers;
    }

    /* @ngNoInject */
    run(callback) {
        forEach(this.providers || [], (provider) => {
            try {
                return callback(provider);
            } catch (exception) {
                return null;
            }
        });
    }

    trackPageView(...args) {
        return this.run((provider) => provider.trackPageView(...args));
    }

    trackClientError(...args) {
        return this.run((provider) => provider.trackClientError(...args));
    }

    trackApiError(...args) {
        return this.run((provider) => provider.trackApiError(...args));
    }

    trackSessionEnd(...args) {
        return this.run((provider) => provider.trackSessionEnd(...args));
    }

    trackSignUp(...args) {
        return this.run((provider) => provider.trackSignUp(...args));
    }

    trackCalendarSpecificMonthSelect(...args) {
        return this.run((provider) => provider.trackCalendarSpecificMonthSelect(...args));
    }

    trackCalendarPreviousMonthSelect(...args) {
        return this.run((provider) => provider.trackCalendarPreviousMonthSelect(...args));
    }

    trackCalendarNextMonthSelect(...args) {
        return this.run((provider) => provider.trackCalendarNextMonthSelect(...args));
    }

    trackCalendarTodaySelect(...args) {
        return this.run((provider) => provider.trackCalendarTodaySelect(...args));
    }

    trackCategoryCreate(...args) {
        return this.run((provider) => provider.trackCategoryCreate(...args));
    }

    trackCategoryUpdate(...args) {
        return this.run((provider) => provider.trackCategoryUpdate(...args));
    }

    trackCategoryDelete(...args) {
        return this.run((provider) => provider.trackCategoryDelete(...args));
    }

    trackTransactionTransferCreate(...args) {
        return this.run((provider) => provider.trackTransactionTransferCreate(...args));
    }

    trackTransactionEventCreate(...args) {
        return this.run((provider) => provider.trackTransactionEventCreate(...args));
    }

    trackTransactionBalanceUpdateCreate(...args) {
        return this.run((provider) => provider.trackTransactionBalanceUpdateCreate(...args));
    }

    trackTransactionDelete(...args) {
        return this.run((provider) => provider.trackTransactionDelete(...args));
    }

    trackTransactionLabelSuggestionAutocomplete(...args) {
        return this.run((provider) => provider.trackTransactionLabelSuggestionAutocomplete(...args));
    }

    trackTransactionAutocategoryOverride(...args) {
        return this.run((provider) => provider.trackTransactionAutocategoryOverride(...args));
    }

    trackTransactionMove(...args) {
        return this.run((provider) => provider.trackTransactionMove(...args));
    }

    trackTransactionSignChange(...args) {
        return this.run((provider) => provider.trackTransactionSignChange(...args));
    }

    trackTransactionTransferCalendarSwitch(...args) {
        return this.run((provider) => provider.trackTransactionTransferCalendarSwitch(...args));
    }

    trackTransactionTypeChange(...args) {
        return this.run((provider) => provider.trackTransactionTypeChange(...args));
    }

    trackTransactionConfirmChange(...args) {
        return this.run((provider) => provider.trackTransactionConfirmChange(...args));
    }

    trackTransactionSearch(...args) {
        return this.run((provider) => provider.trackTransactionSearch(...args));
    }

    trackProfilePasswordChange(...args) {
        return this.run((provider) => provider.trackProfilePasswordChange(...args));
    }

    trackRenewNotificationRenew(...args) {
        return this.run((provider) => provider.trackRenewNotificationRenew(...args));
    }

    trackRenewNotificationSelectDefaultCalendar(...args) {
        return this.run((provider) => provider.trackRenewNotificationSelectDefaultCalendar(...args));
    }

    trackDashboardSelectIncome(...args) {
        return this.run((provider) => provider.trackDashboardSelectIncome(...args));
    }

    trackDashboardSelectExpense(...args) {
        return this.run((provider) => provider.trackDashboardSelectExpense(...args));
    }

    trackDashboardToggleCategoryGroup(...args) {
        return this.run((provider) => provider.trackDashboardToggleCategoryGroup(...args));
    }

    trackDashboardClickEventGroup(...args) {
        return this.run((provider) => provider.trackDashboardClickEventGroup(...args));
    }

    trackPlanSubscribeFromSidebar(...args) {
        return this.run((provider) => provider.trackPlanSubscribeFromSidebar(...args));
    }

    trackPlanRenewFromSidebar(...args) {
        return this.run((provider) => provider.trackPlanRenewFromSidebar(...args));
    }

    trackModalDismissByBackdrop(...args) {
        return this.run((provider) => provider.trackModalDismissByBackdrop(...args));
    }

    trackModalDismissByShortcut(...args) {
        return this.run((provider) => provider.trackModalDismissByShortcut(...args));
    }

    trackModalDismissByTrigger(...args) {
        return this.run((provider) => provider.trackModalDismissByTrigger(...args));
    }
}

export default new AnalyticsService();



// WEBPACK FOOTER //
// ./src/common/analytics/index.js